import './style.scss';
import React from 'react';
import { Link } from 'react-router-dom';
import Tags from 'components/molecules/Tags';

function ImpactCard(props) {
  const { task } = props;

  var tags = [
    {
      "gid": "status"
      , "name": props.task.status
    }
  ];

  return (
    <div className="TaskCard" key={task.gid}>
      <div className="TaskCard__main">
        <Link className="TaskCard__link" to={"/" + props.warehouseId + "/impact/" + task.id}>
          <h3 className="TaskCard__title">{task.name}</h3>
        </Link>
        <Tags tags={tags} />
      </div>
      <div className="TaskCard__meta">
        <p>{task.summary}</p>
      </div>
    </div>
  );
}

export default ImpactCard;
